export class LocalStorageHelper {
  public static supportsLocalStorage: boolean;
  public static memoryStorage: {[index: string]: string} = {};

  public static testSupportsLocalStorage(): boolean {
    if (this.supportsLocalStorage !== undefined) {
      return this.supportsLocalStorage;
    }

    const testData = "test";
    try {
      localStorage.setItem(testData, testData);
      localStorage.getItem(testData);
      localStorage.removeItem(testData);
      return true;
    }
    catch (e) {
      return false;
    }
  }

  public static setItem(key: string, data: string) {
    const dataToSave = data ?? undefined; // Prevent accidentally saving `"null"`

    if (this.testSupportsLocalStorage()) {
      localStorage.setItem(key, dataToSave);
    }
    else {
      this.memoryStorage[key] = dataToSave;
    }
  }

  public static setItems(records: { [key: string]: string }) {
    for (const key of Object.keys(records)) {
      this.setItem(key, records[key]);
    }
  }

  public static getItem(key: string) {
    const val = this.testSupportsLocalStorage()
      ? localStorage.getItem(key)
      : this.memoryStorage[key];

    return val === "undefined" ? null : val;
  }

  public static getItems(keys: string[]): { [key: string]: string | null} {
    const memo: {[index: string]: string | null} = {};
    for (const key of keys) {
      memo[key] = this.getItem(key);
    }
    return memo;
  }

  public static removeItem(key: string) {
    if (this.testSupportsLocalStorage()) {
      localStorage.removeItem(key);
    }
    else {
      delete this.memoryStorage[key];
    }
  }

  public static getUserId(): number | undefined {
    const userJson = this.getItem("user");
    if (userJson) {
      try {
        const user: IUser = JSON.parse(userJson);
        if (user) {
          return user.id;
        }
      }
      catch (e) {
        return;
      }
    }
  }
}
